import { SmsAllocationCompanyDetailsOutput } from './sms-allocation-company-details-output.model';


export class SmsAllocationOutput implements ISmsAllocationOutput {
    /** The auto-generated id of the sms allocation master */
    sms_allocation_id!: number;
    /** The sms allocation name with 255 character limit */
    sms_allocation_name!: string;
    /** The company details type must be one of "All" or "Select" */
    company_detail_type!: string;
    /** The activation date with 10 character limit */
    activation_date!: string;
    /** The expiry date with 10 character limit */
    expiry_date!: string;
    /** The available sms with 500 character limit */
    available_sms!: string;
    /** Max sms allocation */
    max_sms!: number;
    /**  Monthly max sms allocation */
    monthly_max_sms!: number;
    /**  daily max sms allocation */
    daily_max_sms!: number;
    sms_allocation_company_details!: SmsAllocationCompanyDetailsOutput[];
    status!: number;

    constructor(data?: ISmsAllocationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sms_allocation_id = _data["sms_allocation_id"];
            this.sms_allocation_name = _data["sms_allocation_name"];
            this.company_detail_type = _data["company_detail_type"];
            this.activation_date = _data["activation_date"];
            this.expiry_date = _data["expiry_date"];
            this.available_sms = _data["available_sms"];
            this.max_sms = _data["max_sms"];
            this.monthly_max_sms = _data["monthly_max_sms"];
            this.daily_max_sms = _data["daily_max_sms"];
            if (Array.isArray(_data["sms_allocation_company_details"])) {
                this.sms_allocation_company_details = [] as any;
                for (let item of _data["sms_allocation_company_details"])
                    this.sms_allocation_company_details!.push(SmsAllocationCompanyDetailsOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SmsAllocationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SmsAllocationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sms_allocation_id"] = this.sms_allocation_id;
        data["sms_allocation_name"] = this.sms_allocation_name;
        data["company_detail_type"] = this.company_detail_type;
        data["activation_date"] = this.activation_date;
        data["expiry_date"] = this.expiry_date;
        data["available_sms"] = this.available_sms;
        data["max_sms"] = this.max_sms;
        data["monthly_max_sms"] = this.monthly_max_sms;
        data["daily_max_sms"] = this.daily_max_sms;
        if (Array.isArray(this.sms_allocation_company_details)) {
            data["sms_allocation_company_details"] = [];
            for (let item of this.sms_allocation_company_details)
                data["sms_allocation_company_details"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface ISmsAllocationOutput {
    /** The auto-generated id of the sms allocation master */
    sms_allocation_id: number;
    /** The sms allocation name with 255 character limit */
    sms_allocation_name: string;
    /** The company details type must be one of "All" or "Select" */
    company_detail_type: string;
    /** The activation date with 10 character limit */
    activation_date: string;
    /** The expiry date with 10 character limit */
    expiry_date: string;
    /** The available sms with 500 character limit */
    available_sms: string;
    /** Max sms allocation */
    max_sms: number;
    /**  Monthly max sms allocation */
    monthly_max_sms: number;
    /**  daily max sms allocation */
    daily_max_sms: number;
    sms_allocation_company_details: SmsAllocationCompanyDetailsOutput[];
    status: number;
}

